import { Terminal, GitBranch, Clock, CheckCircle, XCircle, Loader2, RefreshCw } from 'lucide-react';
import './TaskCard.css';

const statusIcons = {
  running: Loader2,
  pending: Clock,
  retrying: RefreshCw,
  reviewing: CheckCircle,
  done: CheckCircle,
  failed: XCircle,
};

const statusColors = {
  running: '#3b82f6',
  pending: '#f59e0b',
  retrying: '#f59e0b',
  reviewing: '#8b5cf6',
  done: '#22c55e',
  failed: '#ef4444',
};

const agentEmojis = {
  'claude-sonnet': '⚡',
  'claude-opus': '🧠',
  codex: '🔧',
  kimi: '👁️',
};

function TaskCard({ task }) {
  const StatusIcon = statusIcons[task.status] || Clock;
  const isRunning = task.status === 'running';

  return (
    <div className={`task-card ${task.status}`}>
      <div className="task-card-header">
        <div className="task-id">
          <Terminal size={14} />
          {task.id}
        </div>        
        <div className="task-status" style={{ color: statusColors[task.status] }}>
          <StatusIcon size={14} className={isRunning ? 'spin' : ''} />
          {task.status}
        </div>
      </div>

      <div className="task-body">
        <p className="task-description">{task.description}</p>
        
        <div className="task-meta">
          <span className="agent-badge">
            {agentEmojis[task.agent] || '🤖'} {task.agent}
          </span>
          
          {task.attempts > 1 && (
            <span className="attempts">
              Attempt {task.attempts}/3
            </span>
          )}
        </div>
      </div>

      <div className="task-footer">
        <div className="branch">
          <GitBranch size={12} />
          {task.branch}
        </div>
        
        {task.pr && (
          <a 
            href={task.pr} 
            target="_blank" 
            rel="noopener noreferrer"
            className="pr-link"
          >
            View PR →
          </a>
        )}
      </div>
    </div>
  );
}

export default TaskCard;
